export const normalizeProductStatus = (product) => {
  if (!product || typeof product !== 'object') return product;

  const resolved =
    typeof product.active === 'boolean'
      ? product.active
      : typeof product.is_active === 'boolean'
      ? product.is_active
      : true;

  return {
    ...product,
    active: resolved,
    is_active: resolved,
  };
};

export const buildProductStatusPatch = (value) => {
  const resolved = Boolean(value);
  return {
    active: resolved,
    is_active: resolved,
  };
};

/**
 * Criterio UNICO de "producto disponible para operar".
 *
 * Por que hace falta: `products` arrastra DOS columnas de estado (`active` e
 * `is_active`, deuda vieja documentada en el caso Memo) mas `archived_at` para
 * la baja logica con historial. Cada pantalla filtraba la que se le ocurria:
 * unas `.eq('active', true)`, otras `is_active`, otras nada. Con las columnas
 * sincronizadas no se nota, pero alcanza con que un importador o la API escriba
 * una sola para que el producto dado de baja reaparezca en un selector.
 *
 * El criterio es "no esta desactivado": ninguna de las dos columnas en false y
 * sin archivar. Se usa `.not(col, 'is', false)` y no `.eq(col, true)` a
 * proposito — ambas columnas son nullable con default true, y un null significa
 * "nunca se toco", no "dado de baja".
 *
 * Donde va: TODO selector de operacion nueva (ajustes, transferencias,
 * produccion, compras, combos, listas, POS).
 * Donde NO va: pantallas historicas (kardex, rentabilidad, anulaciones),
 * importadores/exportadores, Recetas y Gestion de Costos — ahi el archivado
 * tiene que verse, con su badge, o se pierde el pasado (ver caso Memo).
 */
export const applyActiveProductsFilter = (query) =>
  query.not('active', 'is', false).not('is_active', 'is', false).is('archived_at', null);

/** Mismo criterio, para filas ya traidas (filtros en cliente). */
export const isProductSelectable = (product) => {
  if (!product || typeof product !== 'object') return false;
  if (product.active === false) return false;
  if (product.is_active === false) return false;
  return !product.archived_at;
};
